import { TypedActorNode } from "./_Base";
import {
  ActorConnectionPointType,
  ActorConnectionPoint
} from "../utils/io/connections/Actor";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { Vector3 } from "three";
const tmpV3 = new Vector3();
class FloatToVec3ActorParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.x = ParamConfig.FLOAT(0);
    this.y = ParamConfig.FLOAT(0);
    this.z = ParamConfig.FLOAT(0);
  }
}
const ParamsConfig3 = new FloatToVec3ActorParamsConfig();
const _FloatToVec3ActorNode = class extends TypedActorNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig3;
  }
  static type() {
    return "floatToVec3";
  }
  initializeNode() {
    this.io.outputs.setNamedOutputConnectionPoints([
      new ActorConnectionPoint(_FloatToVec3ActorNode.OUTPUT_NAME, ActorConnectionPointType.VECTOR3)
    ]);
  }
  outputValue(context, outputName = "") {
    const x = this._inputValueFromParam(this.p.x, context);
    const y = this._inputValueFromParam(this.p.y, context);
    const z = this._inputValueFromParam(this.p.z, context);
    tmpV3.set(x, y, z);
    return tmpV3;
  }
};
export let FloatToVec3ActorNode = _FloatToVec3ActorNode;
FloatToVec3ActorNode.OUTPUT_NAME = "vec3";
